import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { PAGEURL } from '../../../constants'
import RequestConsultationInputs from '../../inputs/RequestConsultationInputs'
import TriNetConsultationInputs from '../../inputs/TriNetConsultationInputs'
import { PageContentLoader } from '../../loaders'
import PopupEnrollRequest from './PopupEnrollRequest'
import styles from '../Marketplace.module.scss'

@inject('store')
@observer
class EnrollRequestForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalClass: ''
    }
  }

  UNSAFE_componentWillMount() {
    const { store, product } = this.props
    if (product.lead_route === 'trinet') {
      store.createFormObject(TriNetConsultationInputs)
      store.formInputs.update(
        'street_address1',
        store.sessionData.userData.street_address1
          ? store.sessionData.userData.street_address1
          : ''
      )
      store.formInputs.update(
        'street_address2',
        store.sessionData.userData.street_address2
          ? store.sessionData.userData.street_address2
          : ''
      )
      store.formInputs.update(
        'state',
        store.sessionData.userData.state ? store.sessionData.userData.state : ''
      )
      store.formInputs.update(
        'city',
        store.sessionData.userData.city ? store.sessionData.userData.city : ''
      )
      store.formInputs.update(
        'zip',
        store.sessionData.userData.zip ? store.sessionData.userData.zip : ''
      )
      store.formInputs.update('industry', '')
      store.formInputs.update('job_title', '')
      store.formInputs.update('number_of_employees', '')
      store.formInputs.update(
        'firm_name',
        store.sessionData.userData.firm_name
          ? store.sessionData.userData.firm_name
          : ''
      )
      this.setState({ modalClass: styles.large_modal })
    } else {
      store.createFormObject(RequestConsultationInputs)
    }
    store.formInputs.update('first_name', store.sessionData.userData.first_name)
    store.formInputs.update('last_name', store.sessionData.userData.last_name)
    store.formInputs.update('email', store.sessionData.userData.email)
    store.formInputs.update('phone', store.sessionData.userData.phone)
  }

  updateUrl = (status) => {
    if (typeof window !== undefined) {
      window.history.replaceState(
        null,
        null,
        `${PAGEURL.PRODUCT_DETAILS}${this.props.product_slug}/consultation/${status}/`
      )
    }
  }

  render() {
    const {
      store,
      product_id,
      company_id,
      enrollment_type,
      product,
      email,
      link
    } = this.props
    let pageContent = ''

    switch (store.consultations.get(product_id).action_type) {
      case 'oasis_request_account_form':
        pageContent = (
          <PopupEnrollRequest
            onClick={(e) => this.props.onClick(e)}
            product_id={product_id}
            company_id={company_id}
            enrollment_type={enrollment_type}
            product={product}
            email={email}
            link={link}
          />
        )
        break
      case 'oasis_in_active_account':
        this.updateUrl('success')
        pageContent = (
          <PopupRequestConsultation
            product_id={product_id}
            company_id={company_id}
            onClick={(e) => this.props.onClick(e)}
            product={product}
            email={email}
            link={link}
          />
        )
        break
      case 'loading':
        pageContent = <PopupLoadingModel />
        break
      case 'exists':
        this.updateUrl('exists')
        pageContent = (
          <EnrollExist
            onClick={(e) => this.props.onClick(e)}
            product_id={product_id}
            product={product}
          />
        )
        break
      default:
        break
    }
    return <div className={styles.consultation_container}>{pageContent}</div>
  }
}

class PopupLoadingModel extends React.Component {
  render() {
    return (
      <div className="modal-content">
        <div className="modal-body">
          <br />
          <br />
          <br />
          <br />
          <br />
          <PageContentLoader />
        </div>
      </div>
    )
  }
}

@inject('store')
@observer
class EnrollExist extends React.Component {
  render() {
    const { product, store } = this.props
    const { siteData } = store
    const msg = `
      You have already requested to connect with ${product.product_name}.
      If you haven't heard from ${
        product.partner.name
      }, please contact ${siteData.get('name')}.
    `
    return (
      <div className={styles.consultation_content}>
        <div className={styles.consultation_header}>
          <h3 className={styles.consultation_title}>Thank you.</h3>
          <button onClick={(e) => this.props.onClick(e)} className="close">
            &times;
          </button>
        </div>
        <div className="modal-body">
          <div>{msg}</div>
        </div>
      </div>
    )
  }
}

@inject('store')
@observer
class PopupRequestConsultation extends React.Component {
  render() {
    const { product } = this.props
    const { calendly_link } = product.enterprise_overrides
    let link = null
    if (this.props.store.isEnterprise()) {
      link = calendly_link !== null ? calendly_link : this.props.link
    } else {
      link = this.props.link
    }
    let title = 'Thank You!'
    let msg = `
      You will receive a confirmation email soon introducing
      you to ${product.partner.name}.
    `
    if (link && link.match(/calendly.com/)) {
      title = 'Scheduled Consultation'
      msg = `
      Thank you for scheduling a consultation. You will receive an email
      shortly confirming your meeting. Don't forget to add it to your calendar.
      `
    }
    return (
      <div className={styles.consultation_content}>
        <div className={styles.consultation_header}>
          <h3 className={styles.consultation_title}>{title}</h3>
          <button onClick={(e) => this.props.onClick(e)} className="close">
            &times;
          </button>
        </div>
        <div className="modal-body">
          <div> {msg} </div>
        </div>
      </div>
    )
  }
}

EnrollRequestForm.propTypes = {
  store: PropTypes.object,
  product_id: PropTypes.node,
  product_slug: PropTypes.node,
  company_id: PropTypes.node,
  enrollment_type: PropTypes.node,
  onClick: PropTypes.func,
  product: PropTypes.object,
  email: PropTypes.string,
  link: PropTypes.string
}

EnrollExist.propTypes = {
  store: PropTypes.object,
  onClick: PropTypes.func,
  product_id: PropTypes.string,
  product: PropTypes.object
}

PopupRequestConsultation.propTypes = {
  store: PropTypes.object,
  product_id: PropTypes.string,
  onClick: PropTypes.func,
  product: PropTypes.object
}

export default EnrollRequestForm
